import React from 'react';
import { useNavigate } from 'react-router-dom';
import { withTheme } from 'styled-components';
import { useSelector } from 'react-redux';
import download_cloud from 'assets/Ui/download-cloud.svg';
import edit from 'assets/Ui/edit.svg';
import aperture from 'assets/Ui/aperture.svg';
import download_format from 'assets/Ui/downloadFormat.gif';
import change_color from 'assets/Ui/changeColor.gif';
import iphone from 'assets/Ui/iPhone-15-Pro-Max.png';
import iphone_15 from 'assets/Ui/iPhone-15.png';
import mug from 'assets/Ui/FOVEA_Mug.png';
import FOVEA_CeramicThumb from 'assets/Ui/FOVEA_CeramicThumb.png';
import iPhone_15_Pro_Max from 'assets/Ui/iPhone_15_Pro_Max.png';
import FOVEA_Photo from 'assets/Ui/FOVEA_Photo.png';
import {
  Section,
  Title,
  Text,
  Wrapper,
  Box,
  BoxesContainer,
  Icon,
  BoxHeader,
  CapabilitiesParagraph,
  OverlapImage,
  ImageContainer,
  ImageView,
} from './styles';
import { HorizontalSpacer, VerticalSpacer } from 'components';
import { CTA } from 'pages/Home/styles';

const HowItWorks = withTheme(props => {
  const { theme } = props;
  const userDataStore = useSelector(state => state.userData);
  const selectedTheme = userDataStore.userPreferences.theme;
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/creators');
  };

  const howItWorksSteps = [
    {
      icon: download_cloud,
      title: 'Use Widely',
      text: `Convert existing assets to a variety of file formats.
             Spend less time opening additional software for conversion.
             FOVEA, a browser-based tool streamlines workflows
             for teams working with the same assets in various programs.`,
    },
    {
      icon: edit,
      title: 'Customize Assets',
      text: `Quickly configure the materials and properties of a model to fit your specific project needs.
             Configuration opportunities include optimization, axis settings, proxy visibility, and more.`,
    },
    {
      icon: aperture,
      title: 'Create 3D Objects',
      text: `Transform images and 3D models into rich, platform-agnostic content known as RPCs.
             Additionally, FOVEA offers the ability to scan real-life objects to create a compatible 3D model.`,
    },
  ];

  return (
    <Wrapper>
      <Section theme={theme} $selectedTheme={selectedTheme} height="963px">
        <VerticalSpacer size={60} />
        <Title size="78px" lineHeight="100px" $selectedTheme={selectedTheme}>How It Works</Title>
        <VerticalSpacer size={60} />
        <Title size="48px" weight={900} selectedTheme={selectedTheme}>
          Content with endless possibilities.
        </Title>
        <VerticalSpacer size={30} />
        <Text maxWidth="1232px" size="24px" margin="0 auto" selectedTheme={selectedTheme}>
          FOVEA™ is a cloud-based 3D model configuration tool that leverages ArchVision’s newest generation RPC,
          Rich Platform Content, technology. Quickly and easily download, customize, optimize, import,
          and create 3D content for publishing to RPC or 3D assets for Enscape, V-Ray, and more.
        </Text>
        <VerticalSpacer size={40} />
        <BoxesContainer>
          {howItWorksSteps.map(({ icon, title, text }) => (
            <Box key={title} w="375px" h="306px" bg="white" content="flex-start">
              <VerticalSpacer size={25} />
              <BoxHeader $selectedTheme={selectedTheme}>
                {<Icon $selectedTheme={selectedTheme} image={icon} w='64px' h='64px' />}
                <HorizontalSpacer size={26} />
                {title}
              </BoxHeader>
              <VerticalSpacer size={15} />
              <Text font="Poppins-Regular" maxWidth="300px" align="none" margin="0 auto" $selectedTheme={selectedTheme}>
                {text}
              </Text>
            </Box>
          ))}
        </BoxesContainer>
        <Box w='50px' h='150px' />
      </Section>
      <Section>
        <VerticalSpacer size={60} />
        <Title size="48px" weight={900} selectedTheme={selectedTheme}>Mobile Capabilities</Title>
        <VerticalSpacer size={60} />
        <BoxesContainer space={60}>
          <Box w='566px' h='384px' >
            <CapabilitiesParagraph fontWeight='600' $selectedTheme={selectedTheme}>
              Platform-agnostic solutions
            </CapabilitiesParagraph>
            <CapabilitiesParagraph $selectedTheme={selectedTheme}>
              Developed to work with an array of platforms,
              FOVEA can export the best file format for your modeling and rendering solutions.
            </CapabilitiesParagraph>
          </Box>
          <ImageView image={download_format} w='608px' h='384px' />
        </BoxesContainer>
        <VerticalSpacer size={170} />
        <BoxesContainer space={60} h="500px">
          <ImageView image={change_color} w='608px' h='384px' />
          <Box w='40px' h='384px' />
          <Box w='556px' h='384px' >
            <CapabilitiesParagraph $selectedTheme={selectedTheme} fontWeight='600'>
              Manage and curate created content
            </CapabilitiesParagraph>
            <CapabilitiesParagraph $selectedTheme={selectedTheme}>
              When exporting as a RPC, models can be displayed in your modeling application as simple
              as a bounding box, 3D billboard,
              adjustable quality preview mesh, or custom mesh.
            </CapabilitiesParagraph>
          </Box>
        </BoxesContainer>
        <VerticalSpacer size={150} />
        <BoxesContainer space={60}>
          <Box w='564px' h='384px' >
            <CapabilitiesParagraph $selectedTheme={selectedTheme} fontWeight='600'>
              Embrace versatility
            </CapabilitiesParagraph>
            <CapabilitiesParagraph $selectedTheme={selectedTheme}>
              Easily configure, customize, and optimize your assets.
            </CapabilitiesParagraph>
          </Box>
          <ImageView image={iphone} w='450px' h='415px' />
        </BoxesContainer>
        <VerticalSpacer size={150} />
        <BoxesContainer space='320px'>
          <Box w='50px' h='383px' />
          <Box w='370px' h='383px' >
            <ImageView image={iphone_15} w='185px' h='383px' />
          </Box>
          <Box w='534px' h='397px' >
            <CapabilitiesParagraph $selectedTheme={selectedTheme} fontWeight='600'>
              Create your own content.
            </CapabilitiesParagraph>
            <CapabilitiesParagraph $selectedTheme={selectedTheme}>
              Get started by adding a photo, scanning an object, or importing an existing 3D model.
            </CapabilitiesParagraph>
          </Box>
        </BoxesContainer>
        <VerticalSpacer size={150} />
        <Title size="48px" weight={900} selectedTheme={selectedTheme}>
          Easily convert real life objects to assets <br />for your 3D scene
        </Title>
        <VerticalSpacer size={50} />
        <BoxesContainer>
          <ImageContainer>
            <OverlapImage image={FOVEA_Photo} top="0px" left="0px" w="292px" h="264.2px" />
            <OverlapImage image={iPhone_15_Pro_Max} top="0px" left="215px" w="373px" h="262.2px" />
            <OverlapImage image={mug} top="275px" left="0px" w="818px" h="492.5px" />
            <OverlapImage image={FOVEA_CeramicThumb} top="60px" left="auto" right="25px" w="251px" h="261.2px" />
          </ImageContainer>
        </BoxesContainer>
        <BoxesContainer>
          <VerticalSpacer size={30} />
          <CTA $selectedTheme={selectedTheme} onClick={handleClick}>
            Explore Content
          </CTA>
        </BoxesContainer>
        <VerticalSpacer size={50} />
      </Section>
    </Wrapper>
  );
});

export { HowItWorks };
